import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Dropdown,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Spin,
  Steps,
  Table,
  Tooltip,
  Typography,
} from "../../../components/common/utils/antd-imports/AntdImports";
import "./CampaignPayments.css";
import "./RevampCampaignPayment.css";
import "./NegotiationTerms.css";
import "../../../styles/GlobalStyle.css";
import { ReactComponent as BackButton } from "../../../assests/left-arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowRightOutlined,
  CalendarOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DownOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  PauseCircleOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  buyerCampaigns,
  defaultTermsBookingStatus,
  deleteCampaignProduct,
  deleteTermsFromCheckOut,
  getCampaignsForPurchase,
  updateProductQty,
  updateTermsToCampaigns,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import "../../../main.css";
import { useMediaQuery } from "react-responsive";
import { getDefaultPaymentTerms } from "../../../store/thunks/common-thunks/commonThunk";
import {
  formatToUSCurrency,
  formatToMMDDYYYY,
  handleCopy,
} from "../../../components/common/utils/Utils";
import { ReactComponent as Warning } from "../../../assests/emojione_warning.svg";
import { ReactComponent as Delete } from "../../../assests/delete_icon.svg";
import { ReactComponent as CollapseArrow } from "../../../assests/CollapseArrow.svg";
import { ReactComponent as WarningBlue } from "../../../assests/warning-icon-blue.svg";
import { ReactComponent as MinimiseIcon } from "../../../assests/minimise-icon.svg";
import { ReactComponent as ChatWhiteIcon } from "../../../assests/chat-white-icon.svg";
import { ReactComponent as ChatSendIcon } from "../../../assests/chat-send-icon.svg";
import { ReactComponent as MessageOutlined } from "../../../assests/message-outlined.svg";
import { ReactComponent as ExportIcon } from "../../../assests/export-icon.svg";
import CustomTermsModal from "../../../components/modal/checkout-page-modal/CustomTermsModal";
import EmptyViewCard from "../../../components/common/empty-view-card/EmptyViewCard";
import DeleteCamapign from "../../../components/modal/delete-campaign/DeleteCampaign";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";
import IoSigining from "./io-signing/IOSigning";
import CampaignPayment from "./checkout-mobile-flow/CampaignPayments";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { Space } from "lucide-react";
import ReusableModal from "../../../components/modal/re-usable-modal/ReusableModal";
import NegotiationChat from "../../../components/common/negotiation-chat/NegotiationChat";
import {
  markProductAsRead,
  setCampaignInfoForChat,
} from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { getChatHistory } from "../../../store/thunks/common-thunks/commonThunk";
import { clearLiveMsgNotificationForProduct } from "../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";
import ProductRequestHoldModal from "../../../components/modal/product-request-hold-modal/ProductRequestHoldModal";
const { Text } = Typography;
const CampaignPayments = (userRole) => {
  const isSmall = useMediaQuery({ maxWidth: 375 });
  const isMedium = useMediaQuery({ minWidth: 769, maxWidth: 1599 });
  const showDates = useMediaQuery({ minWidth: 769, maxWidth: 1200 });
  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = localStorage.getItem("currentStep");
    return savedStep !== null ? Number(savedStep) : 0;
  });
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const [form] = Form.useForm();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [modalType, setModalType] = useState(null);
  const [termsRequest, setTermsRequest] = useState(false);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
  const [termsData, setTermsData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const PDF_BASE_URL = "/pdf";
  const [isHoldRequestModalOpen, setIsHoldRequestModalOpen] = useState(false);
  const [productActionType, setProductActionType] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleRequestHold = (product) => {
    setProductActionType("hold_request");
    setSelectedProduct(product);
    setIsHoldRequestModalOpen(true);
  };
  const {
    purchaseCampaign,
    isLoading: campaignPurchaseLoader,
    totalPriceDetails,
    termsDetails,
  } = useSelector((state) => state?.campaignpurchase);
  const { isLoading: termsCampaignLoader } = useSelector(
    (state) => state?.termsCampaign,
  );
  const { isPaymentLoading } = useSelector((state) => state?.campaignpurchase);
  const { isDeleting } = useSelector((state) => state?.buyerCampaigns);
  const { isdefaultBookingLoading } = useSelector(
    (state) => state?.defaultBookingTerms,
  );
  const isLoading =
    campaignPurchaseLoader ||
    termsCampaignLoader ||
    isPaymentLoading ||
    isDeleting ||
    isdefaultBookingLoading;
  const stepRef = useRef(currentStep);
  const location = useLocation();
  const [expandedCards, setExpandedCards] = useState({});
  const [tableData, setTableData] = useState({});
  const [tableDataRows, setTableDataRows] = useState([]);
  const [isTotalMatched, setIsTotalMatched] = useState(false);
  const [campaignDetails, setCampaignDetails] = useState(null);
  const isDeleteDisabled = totalPriceDetails?.CustomTermsStatus === 0;
  const isWithdrawnTerms = totalPriceDetails?.WithdrawTermStatus === 1;
  const isCustomTermsApplied = totalPriceDetails?.CustomTermsApplied;
  const radioDefaultTerms = totalPriceDetails?.DefaultTermsStatus === 1;
  const radioCustomTerms = totalPriceDetails?.CustomTermsStatus === 1;
  const [selectedRadio, setSelectedRadio] = useState("default");
  const [buttonText, setButtonText] = useState("Proceed with Default Terms");
  const [showCard, setShowCard] = useState(false);
  const [assetActionType, setAssetActionType] = useState(null);
  const [isActionModal, setIsActionModal] = useState(false);
  const [isChat, setIsChat] = useState(false);
  const [selectedChatProduct, setSelectedChatProduct] = useState(null);
  const [campaignDropdownOpen, setCampaignDropdownOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const paymentTermsStatus =
    purchaseCampaign?.length > 0
      ? purchaseCampaign?.map((campaign) => campaign?.payment_terms_status)
      : [];
  const hasCampaignWithStatusTwo =
    purchaseCampaign?.some(
      (campaign) => campaign?.payment_terms_status === 2,
    ) || false;
  const everyCampaignWithStatusTwo =
    purchaseCampaign?.every(
      (campaign) => campaign?.payment_terms_status === 2,
    ) || false;
  const hasWaiting = purchaseCampaign?.some((campaign) =>
    campaign?.booking_array?.some(
      (product) => product?.product_terms_approval === 0,
    ),
  );
  const hasApproved = purchaseCampaign?.some((campaign) =>
    campaign?.booking_array?.some(
      (product) => product?.product_terms_approval === 1,
    ),
  );
  const hasRejected = purchaseCampaign?.some((campaign) =>
    campaign?.booking_array?.some(
      (product) => product?.product_terms_approval === 2,
    ),
  );
  const allWaitingProducts = hasWaiting && !hasApproved && !hasRejected;
  const allApprovedProducts = hasApproved && !hasWaiting && !hasRejected;
  const allRejectedProducts = hasRejected && !hasWaiting && !hasApproved;
  const waitingAndApproved = hasWaiting && hasApproved && !hasRejected;
  const waitingAndRejected = hasWaiting && hasRejected && !hasApproved;
  const approvedAndRejected = hasApproved && hasRejected && !hasWaiting;
  const mixedStatusProducts = hasWaiting && hasApproved && hasRejected;
  const [isNegotiating, setIsNegotiating] = useState(false);
  const [chatInitialTime, setChatInitialTime] = useState("");
  const handleCampaignDetails = (campaign) => {
    dispatch(
      addBreadcrumb({
        title: campaign?.name,
        path: `/buyer/campaigndetails?_id=${btoa(campaign?.id)}`,
      }),
    );
    navigate(`/buyer/campaigndetails?_id=${btoa(campaign?.id)}`);
  };
  useEffect(() => {
    localStorage.setItem("currentStep", String(currentStep));
  }, [currentStep]);
  useEffect(() => {
    if (!isLoggedIn) return;
    const params = new URLSearchParams(location.search);
    const hasStep = params.has("step");
    if (currentStep === 0 && !hasStep) {
      dispatch(getCampaignsForPurchase());
      dispatch(getDefaultPaymentTerms());
    }
  }, [isLoggedIn, currentStep, dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedCampaignId = params.get("campaignId");
    const step = params.get("step");
    // Handle campaign step from URL
    if (step) {
      const requestedStep = Number(step);
      if (!Number.isNaN(requestedStep)) {
        setCurrentStep(requestedStep);
        localStorage.setItem("currentStep", String(requestedStep));
      }
    } else {
      const stepPaths = [
        "/home",
        "/buyer/dashboard",
        "/buyer/products?page=1",
        "/buyer/mycampaigns?segment=saved_campaign",
        "/buyer/viewcart",
        "/buyer/payments",
        "/buyer/campaign-payment",
      ];

      if (stepPaths.includes(location.pathname)) {
        setCurrentStep(0);
      }
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (radioDefaultTerms === undefined || radioCustomTerms === undefined) {
      return;
    }
    const allApprovedProducts =
      purchaseCampaign?.length > 0 &&
      purchaseCampaign?.every((campaign) =>
        campaign?.booking_array?.every(
          (product) => product?.product_terms_approval === 1,
        ),
      );
    if (radioDefaultTerms && radioCustomTerms) {
      setButtonText(
        selectedRadio === "default"
          ? "Proceed with Default Terms"
          : "Request Custom Terms",
      );
    } else if (radioDefaultTerms && !radioCustomTerms) {
      setSelectedRadio("default");
      setButtonText("Proceed with Default Terms");
    } else if (!radioDefaultTerms && radioCustomTerms) {
      setSelectedRadio("custom");
      if (
        isCustomTermsApplied > 0 &&
        isWithdrawnTerms &&
        everyCampaignWithStatusTwo
      ) {
        setButtonText("Proceed with Custom Terms");
      } else if (isCustomTermsApplied > 0 && isWithdrawnTerms && hasWaiting) {
        setButtonText("Waiting for Approval");
      } else if (isCustomTermsApplied > 0 && hasApproved) {
        setButtonText("Proceed with Custom Terms");
      } else {
        setButtonText("Request Custom Terms");
      }
    } else if (totalPriceDetails && !radioDefaultTerms && !radioCustomTerms) {
      setSelectedRadio("custom");
      if (
        isCustomTermsApplied >= 1 &&
        !radioDefaultTerms &&
        !radioCustomTerms &&
        allApprovedProducts
      ) {
        setButtonText("Proceed with Custom Terms");
      } else if (
        !radioDefaultTerms &&
        !radioCustomTerms &&
        isCustomTermsApplied >= 1
      ) {
        setButtonText("Waiting for Approval");
      }
    }
  }, [
    radioDefaultTerms,
    radioCustomTerms,
    isCustomTermsApplied,
    isWithdrawnTerms,
    everyCampaignWithStatusTwo,
    selectedRadio,
    purchaseCampaign,
    totalPriceDetails,
    hasWaiting,
  ]);

  useEffect(() => {
    const savedStep = parseInt(localStorage.getItem("currentStep"));
    if (!isNaN(savedStep)) {
      setCurrentStep(savedStep);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("currentStep", currentStep?.toString());
  }, [currentStep]);
  const handleStepChange = (value) => {
    const params = new URLSearchParams(location.search);
    const hasStep = params.has("step");
    if (value === 0 && hasStep && currentStep === 1) {
      params.delete("step");
      const newSearch = params.toString();
      navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ""}`, {
        replace: true,
      });
      setCurrentStep(0);
      return;
    }
    if (value <= currentStep) {
      setCurrentStep(value);
    } else {
      message.warning(
        `Please click the '${buttonText}' to continue to the next step.`,
      );
    }
  };
  const shouldDisable =
    (((radioDefaultTerms &&
      radioCustomTerms &&
      selectedRadio === "custom" &&
      !isTotalMatched) ||
      (!radioDefaultTerms && radioCustomTerms && isCustomTermsApplied == 0) ||
      (!radioDefaultTerms && !radioCustomTerms && isCustomTermsApplied < 1) ||
      (!radioDefaultTerms &&
        !radioCustomTerms &&
        isCustomTermsApplied > 0 &&
        isWithdrawnTerms == 1 &&
        !everyCampaignWithStatusTwo)) &&
      !(
        !radioDefaultTerms &&
        radioCustomTerms &&
        isCustomTermsApplied > 0 &&
        isWithdrawnTerms == 1 &&
        everyCampaignWithStatusTwo
      )) ||
    (!radioDefaultTerms && radioCustomTerms && hasWaiting) ||
    (!radioDefaultTerms && radioCustomTerms && hasRejected) ||
    purchaseCampaign?.length <= 0;

  const steps = [{ title: "Review & Customize" }, { title: "IO Signing" }];
  const numberedSteps = steps?.map((step, index) => ({
    ...step,
  }));
  const handleRemoveTerms = () => {
    dispatch(deleteTermsFromCheckOut()).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(
          res?.payload?.message || "Terms withdrawn successfully.",
        );
        setTermsRequest(false);
      } else {
        message.error(res?.payload?.message || "Something went wrong.");
      }
      dispatch(getCampaignsForPurchase()).then((action) => {
        const res = action.payload;
        if (res?.status == 0) {
          window.location.reload();
        }
      });
    });
  };

  const goToSecurePayment = () => {
    if (currentStep < numberedSteps.length - 1) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      if (nextStep === 1) {
        const params = new URLSearchParams(location.search);
        params.set("step", "1");
        navigate(`${location.pathname}?${params.toString()}`, {
          replace: true,
        });
      }
    }
  };
  const shouldDisableInput =
    selectedRadio === "default" ||
    totalPriceDetails?.CustomTermsApplied > 0 ||
    (totalPriceDetails?.TermsApplied &&
      Object.keys(totalPriceDetails?.TermsApplied).length > 0);
  const columns = [
    {
      title: "Terms",
      dataIndex: "terms",
      align: "left",
      width: isSmall ? "25%" : 50,
      render: (value, record) =>
        record.terms === "Total" ? (
          <span className="payment-terms-total-price">{value}</span>
        ) : (
          value
        ),
    },
    {
      title: "Seller Terms",
      dataIndex: "sellerTerms",
      align: "right",
      width: 60,
      render: (value, record) =>
        record.terms === "Total" ? (
          <span className="payment-terms-total-price">{value}</span>
        ) : (
          value
        ),
    },
    {
      title: "Your Custom Terms",
      dataIndex: "customTerms",
      align: "right",
      width: 70,
      render: (value, record, index) => {
        if (record?.terms === "Total") {
          // Calculate expected total from seller terms
          const expectedTotal = parseFloat(
            record?.sellerTerms?.replace(/[$,]/g, "") || 0,
          );
          // Sum up custom terms excluding the total row
          const customTotal = tableDataRows
            ?.filter((row) => row?.terms !== "Total")
            ?.reduce(
              (sum, row) => sum + (parseFloat(row?.customTerms) || 0),
              0,
            );
          const remaining = expectedTotal - customTotal;
          return (
            <span className="payment-terms-total-price">
              <Tooltip
                styles={{
                  body: { color: "#fff" },
                }}
                title={
                  <pre className="tooltip-product-card">
                    Your custom terms must total{" "}
                    <span>{record?.sellerTerms}</span> to match the campaign
                    cost
                  </pre>
                }
              >
                <ExclamationCircleOutlined style={{ marginRight: 4 }} />
              </Tooltip>
              {formatToUSCurrency(remaining)}
            </span>
          );
        }

        return (
          <div className="input-warning-icon-payment">
            {record?.showWarning ? (
              <Warning style={{ width: "16px", height: "15px" }} />
            ) : (
              <div className="input-warning-icon-placeholder" />
            )}

            <Input
              className={`enter-amount-custom-input ${
                selectedRadio !== "custom" ? "disabled-opacity" : ""
              }`}
              type="number"
              inputMode="decimal"
              pattern={undefined}
              value={record?.customTerms}
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              min={0}
              disabled={shouldDisableInput}
              addonBefore={<span className="dollar-icon-enter-amount">$</span>}
              placeholder="Amount"
              onChange={(e) => {
                const rawVal = e.target.value;
                const numVal = parseFloat(rawVal) || 0;
                const updatedRows = [...tableDataRows];
                const customTotalExcludingCurrent = updatedRows
                  ?.filter(
                    (_, i) => i !== index && updatedRows[i].terms !== "Total",
                  )
                  ?.reduce(
                    (sum, row) => sum + (parseFloat(row?.customTerms) || 0),
                    0,
                  );
                const expectedTotalRaw =
                  updatedRows?.find((row) => row?.terms === "Total")
                    ?.sellerTerms || "0";
                const expectedTotal =
                  parseFloat(expectedTotalRaw.replace(/[$,]/g, "")) || 0;

                const proposedTotal = customTotalExcludingCurrent + numVal;
                const isExceeding =
                  Number(proposedTotal.toFixed(2)) >
                  Number(expectedTotal.toFixed(2));

                if (isExceeding) {
                  message.warning(
                    "Total custom terms cannot exceed seller terms total.",
                  );
                  return;
                }
                updatedRows[index].customTerms = rawVal;
                const finalRows = updatedRows?.map((row) => ({ ...row }));
                setTableDataRows(finalRows);
                setIsTotalMatched(
                  Number(proposedTotal.toFixed(2)) ===
                    Number(expectedTotal.toFixed(2)),
                );
              }}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (purchaseCampaign?.length > 0) {
      setTableData(termsDetails);
      const firstId = purchaseCampaign[0]?.id;
      if (firstId) {
        setExpandedCards({ [firstId]: true });
      }
    }
  }, [purchaseCampaign, termsDetails]);
  const toggleCard = (id) => {
    setExpandedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const formatTerms = (termKey) => {
    if (termKey.includes("net_")) {
      const days = termKey.match(/\d+/);
      return `Net ${days ? days[0] : ""}`;
    } else if (termKey === "stripe_percent") {
      return "Upfront";
    }
    return termKey;
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedCampaignId = params.get("campaignId");
    if (!encodedCampaignId || !purchaseCampaign?.length) {
      return;
    }
    try {
      const campaignId = atob(encodedCampaignId);
      const matchedCampaign = purchaseCampaign?.find(
        (campaign) => String(campaign?.id) === String(campaignId),
      );
      if (matchedCampaign) {
        setSelectedCampaign(matchedCampaign);
      }
    } catch (error) {
      console.error("Invalid campaignId in URL:", error);
    }
  }, [location.search, purchaseCampaign]);
  useEffect(() => {
    if (tableData?.default_terms_percentage && tableData?.default_terms_total) {
      const percentageObj = tableData?.default_terms_percentage;
      const totalObj = tableData?.default_terms_total;
      const sellerTotalCount = tableData?.default_terms_final_total;
      const approvalWarning = tableData?.terms_auto_approve_flags;
      const termApplied = totalPriceDetails?.TermsApplied;
      const rows = Object.keys(percentageObj).map((termKey, index) => {
        const percentValue = percentageObj[termKey];
        const sellerValue = totalObj[termKey];
        const formattedLabel = formatTerms(termKey); // Displaying the Net 15 etc.. dynamically "
        const formattedPercentage = percentValue;
        const warningFlag = approvalWarning?.[termKey] === 0;

        return {
          key: index + 1,
          terms: `${formattedLabel} (${formattedPercentage}%)`,
          sellerTerms: formatToUSCurrency(Number(sellerValue || 0)),
          showWarning: warningFlag,
          customTerms:
            totalPriceDetails?.CustomTermsApplied > 0 ||
            (totalPriceDetails?.TermsApplied &&
              Object.keys(totalPriceDetails.TermsApplied).length > 0)
              ? Number(termApplied?.[termKey] || 0).toFixed(2)
              : "",
        };
      });
      rows.push({
        key: "total",
        terms: "Total",
        sellerTerms: formatToUSCurrency(sellerTotalCount || 0),
        customTerms: "",
      });
      setTableDataRows(rows);
    }
  }, [
    tableData,
    totalPriceDetails?.CustomTermsApplied,
    totalPriceDetails?.TermsApplied,
  ]);

  useEffect(() => {
    const getNetTermDates = (termsObj, stripeFeeObj) => {
      const today = new Date();
      return Object.entries(termsObj || {})
        ?.filter(
          ([key]) => key?.startsWith("net_") && key?.endsWith("_percent"),
        )
        ?.map(([key, value]) => {
          const days = parseInt(key?.match(/\d+/)[0], 10);
          const futureDate = new Date(today);
          futureDate.setDate(futureDate.getDate() + days);

          return {
            label: `Net ${days}`,
            date: futureDate.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            }),
            value: parseFloat(value?.toFixed(2)),
            stripeFee: isFinite(stripeFeeObj?.[key])
              ? parseFloat(Number(stripeFeeObj[key])?.toFixed(2))
              : 0,
          };
        })
        ?.filter((item) => item?.value > 0);
    };

    if (totalPriceDetails) {
      let data;
      if (totalPriceDetails?.CustomTermsApplied <= 0) {
        // Default terms
        data = getNetTermDates(
          termsDetails?.default_terms_total,
          totalPriceDetails?.TermsStrpeFee,
        );
      } else {
        // Custom terms
        data = getNetTermDates(
          totalPriceDetails?.TermsApplied,
          totalPriceDetails?.TermsStrpeFee,
        );
      }
      setTermsData(data);

      const allValuesZeroExceptStripe = Object.entries(
        totalPriceDetails?.TermsStrpeFee || {},
      )?.every(([key, value]) => {
        if (key === "stripe_percent") return true; // ignore stripe_percent
        return Number(value) === 0;
      });
      if (
        allValuesZeroExceptStripe &&
        totalPriceDetails?.CustomTermsApplied > 0
      ) {
        setShowCard(false);
      } else if (
        allValuesZeroExceptStripe &&
        totalPriceDetails?.CustomTermsApplied <= 0
      ) {
        setShowCard(false);
      } else {
        setShowCard(true);
      }
    }
  }, [
    termsDetails,
    totalPriceDetails?.TermsApplied,
    totalPriceDetails?.TermsStrpeFee,
    totalPriceDetails?.CustomTermsApplied,
    totalPriceDetails,
  ]);

  const requestCustomTerms = () => {
    const today = new Date();
    const payload = {
      percentage_data: [],
      term_type: [],
      calendar_data: [],
    };
    // Iterating teh all rows ovewr the table except the total row
    tableDataRows
      ?.filter((row) => row.terms !== "Total")
      ?.forEach((row) => {
        const amount = parseFloat(row?.customTerms);
        if (!amount || amount <= 0) return;
        payload?.percentage_data?.push(amount); // Extracting the all  net labels  "Net 15 (20%)" → net_15_percent
        const matchedKey = Object?.keys(
          tableData?.default_terms_percentage || {},
        ).find((key) => {
          const formatted = formatTerms(key); // e.g., Net 15
          return row?.terms?.startsWith(formatted);
        });
        if (matchedKey) {
          payload?.term_type?.push(matchedKey);
          let currentDate;
          if (
            matchedKey?.startsWith("net_") &&
            matchedKey?.endsWith("_percent")
          ) {
            const days = parseInt(matchedKey?.match(/\d+/)?.[0], 10);
            const futureDate = new Date(today);
            futureDate?.setDate(today?.getDate() + days);
            currentDate = futureDate;
          } else if (matchedKey === "stripe_percent") {
            currentDate = new Date(today);
          }
          const formattedDate = currentDate
            ?.toLocaleDateString("en-GB")
            ?.replace(/\//g, "-");
          payload?.calendar_data?.push(formattedDate);
        }
      });
    dispatch(updateTermsToCampaigns(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(res?.payload?.message || "Terms applied successfully.");
        setTimeout(() => {
          dispatch(getCampaignsForPurchase());
        }, 500);
        if (res?.payload?.data) {
          setTableData(res?.payload?.data);
        }
      } else if (res?.payload?.status == 0) {
        message.error(res?.payload?.message || "Failed to apply terms.");
      }
    });
    return payload;
  };
  const [assetData, setAssetData] = useState([]);
  const handleDeleteProduct = (campaign) => {
    if (isCustomTermsApplied > 0 && !(campaign?.product_terms_approval === 2)) {
      return;
    }
    setCampaignDetails(campaign);
    setDeleteCampaignModal(true);
  };
  const formatProductPeriod = (fromDate, toDate) => {
    const getDate = (value) => {
      if (!value) return null;
      if (value?.$date?.$numberLong) {
        return new Date(Number(value.$date.$numberLong));
      }
      if (value?.$numberLong) {
        return new Date(Number(value.$numberLong));
      }
      if (typeof value === "object" && value?.date) {
        return new Date(value.date);
      }
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : date;
    };
    const start = getDate(fromDate);
    const end = getDate(toDate);
    if (!start && !end) return "-";
    const formatDate = (date) =>
      date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    if (start && end) {
      return `${formatDate(start)} – ${formatDate(end)}`;
    }

    return formatDate(start || end);
  };
  const getPaymentTerms = (product) => {
    const installments = product?.installments_arr;

    if (!installments) {
      return [];
    }

    const upfrontAmount = Number(installments?.upfront_amount) || 0;
    const upfrontDate = installments?.upfront_date;

    let remainingInstallments = installments?.remaining_installments;

    // Backend sometimes returns object and sometimes array
    if (remainingInstallments && !Array.isArray(remainingInstallments)) {
      remainingInstallments = [remainingInstallments];
    }

    if (!Array.isArray(remainingInstallments)) {
      remainingInstallments = [];
    }

    const totalAmount =
      upfrontAmount +
      remainingInstallments.reduce(
        (sum, item) => sum + (Number(item?.remaining_amount) || 0),
        0,
      );

    const getPercentage = (amount) => {
      if (!totalAmount || !amount) return 0;

      return Math.round((Number(amount) / totalAmount) * 100);
    };

    const paymentTerms = [];

    // Upfront
    if (upfrontAmount > 0 || upfrontDate) {
      paymentTerms.push({
        label: "Upfront",
        date: upfrontDate,
        amount: upfrontAmount,
        percentage: getPercentage(upfrontAmount),
      });
    }

    // Installments
    remainingInstallments.forEach((item, index) => {
      paymentTerms.push({
        label: `Payment.${index + 1}`,
        date: item?.due_date,
        amount: Number(item?.remaining_amount) || 0,
        percentage: getPercentage(item?.remaining_amount),
      });
    });

    return paymentTerms;
  };
  const getBookingStatus = (status) => {
    switch (status) {
      case 2:
        return "Approved";
      case 3:
        return "Negotiating";
      case 1:
      default:
        return "Pending";
    }
  };
  useEffect(() => {
    if (!selectedCampaign?.booking_array) {
      setAssetData([]);
      return;
    }
    const campaignProducts = selectedCampaign.booking_array?.map(
      (product, index) => ({
        key: product?.id || product?._id || index,
        asset: product?.title || "-",
        assetId: product?.siteNo || product?.product_id || "-",
        location:
          [product?.city_name, product?.state_name]
            ?.filter(Boolean)
            ?.join(", ") || "-",

        period: formatProductPeriod(product?.booked_from, product?.booked_to),
        cost: formatToUSCurrency(product?.offerpriceperselectedDates),
        paymentTerms: getPaymentTerms(product),
        status: getBookingStatus(product?.booking_terms_status),
        originalProduct: product,
        campaign_id: product?.campaign_id,
        quantity: product?.quantity,
        available_quantity: product?.available_quantity,
      }),
    );

    setAssetData(campaignProducts);
  }, [selectedCampaign]);
  const AssetName = ({ record }) => (
    <div className="asset-cell">
      <div className="common-text-101828-14">{record?.asset}</div>
      <div className="asset-meta">
        <span className="grey-color-text-99a1af-11">{record?.assetId}</span>
      </div>
    </div>
  );
  const updateSelectedChatProduct = (record, bookingTermsStatus) => {
    setSelectedChatProduct((prev) => {
      // If chat is not currently opened, nothing to update
      if (!prev) return prev;
      const selectedBookingId =
        prev?.originalProduct?.id || prev?.originalProduct?._id || prev?.key;
      const recordBookingId =
        record?.originalProduct?.id ||
        record?.originalProduct?._id ||
        record?.key;
      // Update only the currently opened product
      if (String(selectedBookingId) !== String(recordBookingId)) {
        return prev;
      }
      return {
        ...prev,
        status: getBookingStatus(bookingTermsStatus),
        originalProduct: {
          ...prev?.originalProduct,
          booking_terms_status: bookingTermsStatus,
        },
      };
    });
  };
  const handleStatusChange = (record, status) => {
    const productKey = record?.key;
    const campaignId = record?.campaign_id;
    const productPrice = record?.originalProduct?.price;
    if (status !== "Move" && status !== "Rejected") {
      setAssetData((prev) =>
        prev?.map((item) =>
          item?.key === productKey ? { ...item, status } : item,
        ),
      );
    }

    setAssetActionType(status);
    if (status === "Approved") {
      const payload = {
        terms_status:
          record?.originalProduct?.booking_terms_status === 2 ? 1 : 2,
        product_booking_id: productKey,
      };
      const product = record?.originalProduct;
      const bookingId = String(product?.id);
      dispatch(defaultTermsBookingStatus(payload)).then((res) => {
        if (res?.payload?.status == 1) {
          const updatedBookingTermsStatus =
            record?.originalProduct?.booking_terms_status === 2 ? 1 : 2;
          updateSelectedChatProduct(record, updatedBookingTermsStatus);
          dispatch(getCampaignsForPurchase());
          dispatch(
            getChatHistory({
              campaignId,
              bookingId,
            }),
          );
        }
      });

      setIsNegotiating(false);
    }
    if (status === "Negotiating") {
      setIsNegotiating(true);
    }
    if (status === "Move") {
      setCampaignDetails(record);
      setIsActionModal(true);
    }
    if (status === "Rejected") {
      const payload = {
        campaignId,
        productId: productKey,
        price: productPrice,
      };
      const product = record?.originalProduct;
      const bookingId = String(product?.id);
      dispatch(deleteCampaignProduct(payload)).then((res) => {
        if (res?.payload?.status == 1) {
          message.success(res?.payload?.message);
          dispatch(getCampaignsForPurchase());
          dispatch(buyerCampaigns(campaignId));
          dispatch(
            getChatHistory({
              campaignId,
              bookingId,
            }),
          );
        } else {
          message.error(res?.payload?.message);
        }
      });

      setIsNegotiating(false);
    }
  };

  const cols = [
    {
      title: "ASSET",
      key: "asset",
      width: isSmall ? "25%" : "23%",
      render: (_, record) => {
        const expired =
          Number(
            record?.expired_status ?? record?.originalProduct?.expired_status,
          ) === 1;

        const soldOut =
          Number(
            record?.sold_status ?? record?.originalProduct?.sold_status,
          ) === 1;
        return (
          <div
            style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}
          >
            <AssetName record={record} />
            {(expired || soldOut) && (
              <div className="payment-terms-row">
                <span className="payment-term-badge payment-term-upfront">
                  {expired && soldOut
                    ? "Expired • Sold Out"
                    : expired
                      ? "Expired"
                      : "Sold Out"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "LOCATION",
      key: "location",
      width: isSmall ? "20%" : "15%",
      render: (_, record) => (
        <div className="location-cell">
          <EnvironmentOutlined style={{ width: "12px", height: "auto" }} />
          <span className="common-text-4a5565-12">{record.location}</span>
        </div>
      ),
    },
    {
      title: "CAMPAIGN PERIOD",
      key: "period",
      width: isSmall ? "17%" : "16%",
      render: (_, record) => (
        <div className="period-cell">
          <CalendarOutlined style={{ width: "12px", height: "auto" }} />
          <span className="common-text-4a5565-12">{record.period}</span>
        </div>
      ),
    },
    {
      title: "COST",
      key: "cost",
      width: isSmall ? "10%" : "10%",
      render: (_, record) => (
        <span className="common-text-d2042d-14">{record?.cost}</span>
      ),
    },
    {
      title: "DEFAULT PAYMENT SCHEDULE",
      key: "paymentTerms",
      width: isSmall ? "15%" : "14%",
      render: (_, record) => {
        const terms = record?.paymentTerms;

        if (!terms?.length) {
          return <span className="common-text-4a5565-12">-</span>;
        }

        return (
          <div className="payment-terms-cell">
            <>
              {terms?.map((term, index) => (
                <div key={index} className="payment-terms-row">
                  <span
                    className={
                      term.label === "Upfront"
                        ? "payment-term-badge payment-term-upfront"
                        : "payment-term-badge payment-term-installment"
                    }
                  >
                    {term?.label}
                  </span>
                  <span className="payment-term-date">
                    {term?.date
                      ? new Date(term?.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        })
                      : "-"}
                  </span>
                  <span className="payment-term-amount-new">
                    {term?.amount > 0 ? formatToUSCurrency(term?.amount) : "-"}
                  </span>
                  <span className="payment-term-percentage">
                    ({term?.percentage}%)
                  </span>
                </div>
              ))}
              <Tooltip title={record?.originalProduct?.cancellation_terms}>
                <span
                  className="payment-term-badge "
                  style={{
                    color: "#d2042d",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Payment Message
                </span>
              </Tooltip>
            </>
          </div>
        );
      },
    },
    {
      title: "STATUS",
      key: "status",
      width: isSmall ? "8%" : "9%",
      render: (_, record) => (
        <span
          className={`common-text-D1D5DC-12 asset-status asset-status-${record.status
            ?.toLowerCase()
            .replace(/\s+/g, "-")}`}
        >
          {record?.status}
        </span>
      ),
    },
    {
      title: "ACTIONS",
      key: "actions",
      width: isSmall ? "9%" : "13%",
      render: (_, record) => {
        const expired =
          Number(
            record?.expired_status ?? record?.originalProduct?.expired_status,
          ) === 1;

        const soldOut =
          Number(
            record?.sold_status ?? record?.originalProduct?.sold_status,
          ) === 1;
        const isUnavailable = expired || soldOut;
        const isApproved = record?.originalProduct?.booking_terms_status == 2;
        const buttonClass = [
          "action-items-payment-accept-btn",
          isApproved && "action-items-payment-reject-btn",
          isUnavailable && "disabled-opacity",
        ]
          ?.filter(Boolean)
          ?.join(" ");
        const holdApprovalStatus = Number(
          record?.originalProduct?.hold_approval_status ?? 0,
        );
        const isHoldApproved = holdApprovalStatus == 1;
        const isHoldDisabled = !isApproved || soldOut || expired;
        return (
          <div className="asset-actions">
            <Tooltip
              title={
                record?.originalProduct?.booking_terms_status === 2
                  ? "Remove approval"
                  : "Approve"
              }
            >
              <Button
                className={buttonClass}
                disabled={isUnavailable}
                icon={
                  record?.originalProduct?.booking_terms_status == 2 ? (
                    <CloseOutlined
                      style={{
                        width: "14px",
                        height: "auto",
                      }}
                    />
                  ) : (
                    <CheckOutlined
                      style={{
                        width: "14px",
                        height: "auto",
                      }}
                    />
                  )
                }
                onClick={() => handleStatusChange(record, "Approved")}
              />
            </Tooltip>
            <Tooltip
              title={
                record?.originalProduct?.booking_terms_status === 2
                  ? "Product already approved"
                  : "Negotiate"
              }
            >
              <Button
                className={`action-items-payment-chat-btn ${soldOut || expired ? "disabled-opacity" : ""}`}
                disabled={soldOut || expired}
                icon={
                  <MessageOutlined
                    style={{
                      width: "14px",
                      height: "auto",
                    }}
                  />
                }
                onClick={() => {
                  const product = record?.originalProduct;
                  const campaignId = String(product?.campaign_id);
                  const bookingId = String(product?.id);
                  setSelectedChatProduct(record);
                  setIsChat(true);
                  setChatInitialTime(
                    new Date().toLocaleTimeString([], {
                      hour: "numeric",
                      minute: "2-digit",
                    }),
                  );
                  setIsNegotiating(true);
                  // Get existing chat history
                  dispatch(
                    getChatHistory({
                      campaignId,
                      bookingId,
                    }),
                  );

                  // Mark chat as read
                  dispatch(
                    markProductAsRead({
                      campaignId,
                      productId: bookingId,
                      readAt: Date.now(),
                    }),
                  );

                  // Remove live notification
                  dispatch(
                    clearLiveMsgNotificationForProduct({
                      campaignId,
                      productId: bookingId,
                    }),
                  );
                }}
              />
            </Tooltip>
            <Tooltip title="Move to campaign">
              <Button
                className="action-items-payment-move-btn"
                icon={
                  <ArrowRightOutlined
                    style={{
                      width: "14px",
                      height: "auto",
                    }}
                  />
                }
                onClick={() => handleStatusChange(record, "Move")}
              />
            </Tooltip>
            <Tooltip
              title={
                isHoldApproved
                  ? "Product is already on hold"
                  : "Product booking dates hold request"
              }
            >
              <Button
                type="text"
                className={`action-items-payment-chat-btn ${
                  isHoldDisabled ? "disabled-opacity" : ""
                }`}
                icon={<PauseCircleOutlined />}
                onClick={() => handleRequestHold(record?.originalProduct)}
                disabled={isHoldDisabled}
              />
            </Tooltip>
            <Tooltip
              title={
                selectedCampaign?.offer_disable === 1
                  ? "You can't perform this action when the offer is applied"
                  : "Delete product"
              }
            >
              <Button
                className={`action-items-payment-reject-btn ${selectedCampaign?.offer_disable === 1 ? "" : ""}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                disabled={selectedCampaign?.offer_disable === 1}
                icon={
                  <Delete
                    style={{
                      color: "#d2042d",
                      width: "14px",
                      height: "auto",
                    }}
                  />
                }
                onClick={() => handleStatusChange(record, "Rejected")}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (!purchaseCampaign?.length) {
      setSelectedCampaign(null);
      return;
    }
    const params = new URLSearchParams(location.search);
    const encodedCampaignId = params.get("campaignId");
    let campaignIdFromUrl = null;
    if (encodedCampaignId) {
      try {
        campaignIdFromUrl = encodedCampaignId;
      } catch (error) {
        console.error("Invalid campaignId in URL:", error);
      }
    }
    if (campaignIdFromUrl) {
      const campaignFromUrl = purchaseCampaign?.find(
        (campaign) => String(campaign?.id) === String(campaignIdFromUrl),
      );
      if (campaignFromUrl) {
        setSelectedCampaign(campaignFromUrl);
        return;
      }
    }

    setSelectedCampaign((prev) => {
      const existingCampaign = purchaseCampaign.find(
        (campaign) => String(campaign?.id) === String(prev?.id),
      );

      return existingCampaign || purchaseCampaign[0];
    });
  }, [purchaseCampaign, location.search]);
  const selectedCampaignProducts = selectedCampaign?.booking_array || [];

  const selectedCampaignAcceptedCount = selectedCampaignProducts.filter(
    (product) => Number(product?.booking_terms_status) === 2,
  ).length;

  const selectedCampaignNegotiatingCount = selectedCampaignProducts.filter(
    (product) => Number(product?.booking_terms_status) === 3,
  ).length;

  const selectedCampaignAcceptedAmount = selectedCampaignProducts
    ?.filter((product) => Number(product?.booking_terms_status) === 2)
    ?.reduce(
      (total, product) =>
        total + (Number(product?.offerpriceperselectedDates) || 0),
      0,
    );
  const allProductsApproved =
    selectedCampaign?.booking_array?.length > 0 &&
    selectedCampaign.booking_array.every(
      (product) => product?.booking_terms_status === 2,
    );
  const isCampaignPurchaseDisabled =
    Number(selectedCampaign?.campaign_purchase_disable) === 1;

  return (
    <>
      <div className="purchase-main-component">
        <div>
          {/* <div className={`complete-campaign-text-row-bread `}>
                <BreadcrumbNav />
              </div> */}
          <Row className={` re-design-campaign-selection-row`}>
            <Col>
              {currentStep === 0 && (
                <Row>
                  <Col>
                    <BackButton
                      onClick={(e) => {
                        if (currentStep === 0) {
                          navigate("/buyer/viewcart");
                        } else {
                          stepRef.current = Math.max(stepRef.current - 1, 0);
                          setCurrentStep(stepRef.current);
                        }
                      }}
                      className=" back-arrow-payment-main"
                    />
                  </Col>
                  <Col className="re-design-campaign-selection-col">
                    <Dropdown
                      open={campaignDropdownOpen}
                      onOpenChange={setCampaignDropdownOpen}
                      trigger={["click"]}
                      dropdownRender={() => (
                        <div className="campaign-selection-dropdown">
                          {purchaseCampaign?.length > 0 ? (
                            purchaseCampaign?.map((campaign, index) => (
                              <div
                                key={campaign?.id ?? index}
                                className={`campaign-dropdown-item ${
                                  selectedCampaign?.id === campaign?.id
                                    ? "selected-campaign"
                                    : ""
                                }`}
                                onClick={() => {
                                  setSelectedCampaign(campaign);
                                  setCampaignDropdownOpen(false);
                                  const encodedCampaignId = btoa(
                                    String(campaign?.id),
                                  );
                                  const params = new URLSearchParams(
                                    location.search,
                                  );
                                  params.set("campaignId", encodedCampaignId);

                                  navigate(
                                    `${location.pathname}?${params.toString()}`,
                                    {
                                      replace: true,
                                    },
                                  );
                                }}
                              >
                                <div className="campaign-dropdown-header">
                                  <div>
                                    <Text className="campaign-dropdown-name">
                                      {campaign?.name}
                                    </Text>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="campaign-dropdown-empty">
                              No campaigns available
                            </div>
                          )}
                        </div>
                      )}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                      >
                        <Text className="complete-campaign-text common-action-items-text-black-14">
                          {selectedCampaign?.name || ""}
                        </Text>

                        <DownOutlined
                          className={
                            campaignDropdownOpen
                              ? "campaign-dropdown-arrow-open"
                              : ""
                          }
                        />
                      </div>
                    </Dropdown>

                    <Text className="complete-campaign-text common-action-items-text-grey">
                      {selectedCampaign?.booking_array?.length || 0} assets ·
                      Negotiate & Buy
                    </Text>
                  </Col>
                </Row>
              )}
            </Col>

            <Col style={{ display: "flex", gap: "10px" }}>
              <Button
                className={
                  currentStep === 1
                    ? "common-button-green"
                    : "common-button-red"
                }
                onClick={() => handleStepChange(0)}
              >
                <span
                  className={
                    currentStep === 1
                      ? "review-products-count review-products-count-completed"
                      : "review-products-count"
                  }
                >
                  {currentStep === 1 ? <CheckOutlined /> : "1"}
                </span>
                <span
                  className={
                    currentStep === 1
                      ? "common-text-008236-14"
                      : "common-text-white-14"
                  }
                >
                  Review Products
                </span>
              </Button>

              <RightOutlined style={{ color: "#D1D5DC" }} />

              <Button
                className={
                  currentStep === 1 ? "common-button-red" : "common-button-grey"
                }
                onClick={() => handleStepChange(1)}
                disabled={currentStep === 0}
              >
                <span
                  className={
                    currentStep === 1
                      ? "review-products-count"
                      : "review-products-count review-products-count-grey"
                  }
                >
                  2
                </span>

                <span
                  className={
                    currentStep === 1
                      ? "common-text-white-14"
                      : "common-text-99A1AF-14"
                  }
                >
                  Sign IO
                </span>
              </Button>
            </Col>
          </Row>
          {/* <div className="scrollable-content">
                <Row
                  className="review-secure-row"
                  justify={"center"}
                  gutter={[16, 16]}
                >
                  <Steps
                    type="navigation"
                    current={currentStep}
                    initial={0}
                    onChange={handleStepChange}
                    items={numberedSteps}
                    disabled={false}
                    direction={isSmall ? "vertical" : "horizontal"}
                    responsive={false}
                    className="review-steps-custom"
                  />
                </Row>
              </div> */}
        </div>
        <div className="campaign-payment-main-container">
          {currentStep === 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div
                className={`negotiate-terms-container ${isChat ? "negotiate-terms-table-container" : ""}`}
              >
                <div className="review-each-asset-conatiner ">
                  <WarningBlue style={{ width: "14px ", height: "auto" }} />
                  <Text className="common-text-6A7282-14">
                    Review each asset — accept, negotiate, or reject using the
                    icons in the Actions column.
                  </Text>
                </div>
                <div className="assets-table-wrapper">
                  <Table
                    columns={cols}
                    dataSource={assetData}
                    pagination={false}
                    bordered={false}
                    rowClassName="asset-table-row"
                    className="negotiate-assets-table "
                  />
                </div>
                <div className="negotiate-summary">
                  <div className="summary-left">
                    <div className="summary-item">
                      <span className="common-text-6A7282-14">Accepted:</span>
                      <strong className="accepted-value">
                        {" "}
                        {selectedCampaignAcceptedCount}
                      </strong>
                    </div>
                    <div>
                      <span className="common-text-6A7282-14">
                        Negotiating:
                      </span>
                      <strong className="negotiating-value">
                        {" "}
                        {selectedCampaignNegotiatingCount}
                      </strong>
                    </div>
                    <div>
                      <span className="common-text-6A7282-14">
                        Accepted Total:
                      </span>
                      <strong className="total-value">
                        {" "}
                        {formatToUSCurrency(selectedCampaignAcceptedAmount)}
                      </strong>
                    </div>
                  </div>

                  <div className="summary-right">
                    {isChat && selectedChatProduct && (
                      <Button
                        type="default"
                        className="back-review-btn common-text-6A7282-14 all-negotiation-button"
                        onClick={() => {
                          const product = selectedChatProduct?.originalProduct;
                          navigate("/buyer/messages", {
                            state: {
                              negotiation: {
                                campaignId: String(product?.campaign_id),
                                bookingId: String(
                                  product?.productbookingid ||
                                    product?.id ||
                                    product?._id,
                                ),
                                productId:
                                  product?.product_id || product?.siteNo,
                                selectedChatProduct,
                              },
                            },
                          });
                        }}
                      >
                        All Negotiations <ExportIcon />
                      </Button>
                    )}
                    <div className="review-warning">
                      <ExclamationCircleOutlined />
                      <span className="common-text-E17100-12">
                        Review all assets first
                      </span>
                    </div>
                    <Button
                      className={`common-button-red ${
                        !allProductsApproved || isCampaignPurchaseDisabled
                          ? "disabled-opacity"
                          : ""
                      }`}
                      onClick={goToSecurePayment}
                      disabled={
                        !allProductsApproved || isCampaignPurchaseDisabled
                      }
                    >
                      <span className="common-text-white-14">
                        Proceed to Sign IO
                      </span>
                      <ArrowRightOutlined className="common-text-white-14" />
                    </Button>
                  </div>
                </div>
              </div>
              {isChat && (
                <NegotiationChat
                  isChat={isChat}
                  selectedChatProduct={selectedChatProduct}
                  setIsChat={setIsChat}
                  chatInitialTime={chatInitialTime}
                  updateSelectedChatProduct={updateSelectedChatProduct}
                />
              )}

              {/* <Row
                    className="order-summary-apply-term-row"
                    gutter={[24, 24]}
                    style={{ flexFlow: "nowrap" }}
                  >
                    <Col
                      className="order-summary-col"
                      xxl={10}
                      xl={12}
                      lg={13}
                      md={10}
                    >
                      
                      <Card className="card-summary-card">
                        <Row className="order-payment-total-row">
                          <Text className="order-summary-heading">
                            Order Summary
                          </Text>
                          <Text className="order-summary-heading-amount">
                            Total:{"\u00A0"}
                            {formatToUSCurrency(
                              totalPriceDetails?.TotalPrice || 0,
                            )}
                          </Text>
                        </Row>

                        <Divider className="campaign-diver" />
                        <div className="order-summary-scroll-main-container">
                          {purchaseCampaign?.length > 0 ? (
                            purchaseCampaign?.map((campaign, index) => (
                              <div
                                key={campaign?.id ?? index}
                                className="campaign-details-main-div"
                              >
                                <Row
                                  className="urban-billboard-row"
                                  onClick={() => toggleCard(campaign?.id)}
                                >
                                  <Col
                                    style={{
                                      maxWidth: "80%",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    <Row style={{ marginInlineStart: "20px" }}>
                                      <div className="product-copy-text-field">
                                        <Text className="payments-campaign-id">
                                          {" "}
                                          {campaign?.cid}
                                        </Text>
                                        <CopyOutlined
                                          onClick={(e) => {
                                            e.stopPropagation(); // prevent tooltip close
                                            handleCopy(campaign?.cid);
                                          }}
                                          className="copy-icon"
                                        />
                                      </div>
                                    </Row>
                                    <CollapseArrow
                                      className={`collapse-arrow-mark ${
                                        expandedCards[campaign?.id]
                                          ? "open"
                                          : ""
                                      }`}
                                    />

                                    <span className="product-copy-text-field">
                                      <Text
                                        className="urban-billboard-blitz-text truncate"
                                        onClick={() =>
                                          handleCampaignDetails(campaign)
                                        }
                                      >
                                        {campaign?.name}
                                      </Text>
                                      <CopyOutlined
                                        onClick={(e) => {
                                          e.stopPropagation(); // prevent tooltip close
                                          handleCopy(campaign?.name);
                                        }}
                                        className="copy-icon"
                                      />
                                    </span>

                                    {expandedCards[campaign?.id] &&
                                    !showDates ? (
                                      <>
                                        <span className="products-purchase-dates">
                                          {formatToMMDDYYYY(
                                            campaign?.campaign_dates
                                              ?.campaign_start_date,
                                          )}
                                        </span>

                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="11"
                                          height="11"
                                          viewBox="0 0 23 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M22.7071 8.7071C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289L16.3431 0.928931C15.9526 0.538406 15.3195 0.538406 14.9289 0.928931C14.5384 1.31946 14.5384 1.95262 14.9289 2.34314L20.5858 8L14.9289 13.6569C14.5384 14.0474 14.5384 14.6805 14.9289 15.0711C15.3195 15.4616 15.9526 15.4616 16.3431 15.0711L22.7071 8.7071ZM0 9H22V7H0V9Z"
                                            fill="#D2042D"
                                          />
                                        </svg>

                                        <span className="products-purchase-dates">
                                          {formatToMMDDYYYY(
                                            campaign?.campaign_dates
                                              ?.campaign_end_date,
                                          )}
                                        </span>
                                      </>
                                    ) : (
                                      !expandedCards[campaign?.id] && (
                                        <span className="product-count-collapse">
                                          (
                                          {`${
                                            campaign?.booking_array?.length || 0
                                          } Products`}
                                          )
                                        </span>
                                      )
                                    )}
                                  </Col>
                                  <Col>
                                    {expandedCards[campaign?.id] ? (
                                      <Text className="products-text-non">
                                        {`${campaign?.booking_array?.length} Products`}
                                      </Text>
                                    ) : (
                                      <Text className="total-campaign-total-price-text">
                                        {formatToUSCurrency(
                                          campaign?.totalamount || 0,
                                        )}
                                      </Text>
                                    )}
                                  </Col>
                                </Row>

                                {expandedCards[campaign?.id] && (
                                  <>
                                    <Card className="urban-billboard-sub-card">
                                      <Row
                                        className="campaigns-upfront-products-row"
                                        gutter={[16, 16]}
                                      >
                                        <Col>
                                          <Text className="products-text-non">
                                            Products
                                          </Text>
                                        </Col>
                                      </Row>
                                      {campaign?.booking_array?.map(
                                        (products, productIndex) => (
                                          <div key={productIndex}>
                                            <Row
                                              className="time-square-row"
                                              gutter={[16, 16]}
                                            >
                                              <Col className="products-title-col">
                                                <Tooltip
                                                  styles={{
                                                    body: { color: "#fff" },
                                                  }}
                                                  title={
                                                    <pre className="tooltip-product-card">
                                                      {products?.title}
                                                    </pre>
                                                  }
                                                >
                                                  <Text
                                                    className={`time-square-digital-col-text truncate-title-text ${
                                                      totalPriceDetails?.CustomTermsStatus ===
                                                      0
                                                        ? "truncate-title-text-waiting"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    {products?.title}
                                                  </Text>
                                                </Tooltip>
                                                <Delete
                                                  className={
                                                    isCustomTermsApplied > 0 &&
                                                    !(
                                                      products?.product_terms_approval ===
                                                      2
                                                    )
                                                      ? "disabled-opacity"
                                                      : ""
                                                  }
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    cursor: "pointer",
                                                    color: "#000",
                                                  }}
                                                  onClick={() => {
                                                    handleDeleteProduct(
                                                      products,
                                                    );
                                                  }}
                                                />
                                                {totalPriceDetails?.CustomTermsApplied >
                                                  0 && (
                                                  <>
                                                    {products?.product_terms_approval ===
                                                      0 &&
                                                      (window.innerWidth <=
                                                      1440 ? (
                                                        <Tooltip title="Waiting for approval">
                                                          <span className="waiting-for-approval-text truncate-title-text">
                                                            Waiting for approval
                                                          </span>
                                                        </Tooltip>
                                                      ) : (
                                                        <span className="waiting-for-approval-text truncate-title-text">
                                                          Waiting for approval
                                                        </span>
                                                      ))}

                                                    {products?.product_terms_approval ===
                                                      1 && (
                                                      <span className="waiting-for-approval-text approved-text-color ">
                                                        Approved
                                                      </span>
                                                    )}

                                                    {products?.product_terms_approval ===
                                                      2 && (
                                                      <span className="waiting-for-approval-text rejected-text-color ">
                                                        Rejected
                                                      </span>
                                                    )}
                                                  </>
                                                )}
                                              </Col>

                                              <Col className="">
                                                <Text className="time-square-digital-price">
                                                  {formatToUSCurrency(
                                                    products?.offerpriceperselectedDates ||
                                                      0,
                                                  )}
                                                </Text>
                                              </Col>
                                            </Row>
                                          </div>
                                        ),
                                      )}
                                      <Divider className="campaign-diver" />
                                      <Row
                                        gutter={[16, 16]}
                                        className="total-campaign-row"
                                      >
                                        <Col className="products-title-col-value">
                                          <Text className="total-campaign-amount-label-text">
                                            Total Campaign Cost
                                          </Text>
                                        </Col>
                                        <Col
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            width: "25%",
                                          }}
                                          className="total-campaign-total-price-col"
                                        >
                                          <Text className="total-campaign-total-price-text">
                                            {formatToUSCurrency(
                                              campaign?.totalamount || 0,
                                            )}
                                          </Text>
                                        </Col>
                                      </Row>
                                    </Card>
                                  </>
                                )}
                              </div>
                            ))
                          ) : (
                            <div className="seller-rfp-empty-list-div payments-empty-campaigns-container">
                              <EmptyViewCard
                                header={"Campaigns added..."}
                                text={
                                  "It looks like you haven't purchased any campaigns"
                                }
                              />
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                    <Col
                      className="apply-term-main-col"
                      xxl={7}
                      xl={11}
                      lg={11}
                    >
                      <Card className="proceed-to-payment-card">
                        <Row className="terms-withdrawn-row">
                          <Text className="apply-term-text">Payment Terms</Text>
                          {paymentTermsStatus?.includes(3) && (
                            <div className="withdrawn-text-badge">
                              <Text className="apply-term-text withdrawn-text">
                                Terms Withdrawn
                              </Text>
                            </div>
                          )}
                        </Row>
                        <Row className="campaign-payment-table-row">
                          <Table
                            columns={columns}
                            dataSource={tableDataRows}
                            pagination={false}
                            scroll={{ x: "450px" }}
                            className="campaign-payment-table"
                            tableLayout="fixed"
                          />
                        </Row>
                        <Row className="seller-approval-warning-row">
                          <Col style={{ width: "10%", alignItems: "center" }}>
                            <Warning className="seller-approval-warning-icon" />
                          </Col>

                          <Col style={{ width: "90%" }}>
                            <Text className="cancel-campaign-text">
                              This term requires seller approval. We’ll notify
                              you once the seller responds
                            </Text>
                          </Col>
                        </Row>
                        <Row className="amp-note-store-margin-card">
                          <Radio.Group
                            value={selectedRadio}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (isDeleteDisabled) return;
                              setSelectedRadio(value);
                              if (value === "default") {
                                const clearedRows = tableDataRows?.map(
                                  (row) => ({
                                    ...row,
                                    customTerms:
                                      row?.terms !== "Total"
                                        ? ""
                                        : row?.customTerms,
                                  }),
                                );
                                setTableDataRows(clearedRows);
                                setIsTotalMatched(false);
                              }
                            }}
                            className={`custom-radio-group ${
                              isDeleteDisabled ? "disable-opacity" : ""
                            }`}
                          >
                            <Radio
                              value={"default"}
                              className={`
    ${selectedRadio === "default" ? "radio-active" : "radio-inactive"} 
    ${!radioDefaultTerms && isCustomTermsApplied > 0 ? "disable-pointer" : ""}
  `}
                            >
                              Default Terms
                            </Radio>
                            <Radio
                              value={"custom"}
                              className={
                                selectedRadio === "custom"
                                  ? "radio-active"
                                  : "radio-inactive"
                              }
                            >
                              Custom Terms
                            </Radio>
                          </Radio.Group>
                        </Row>
                        <Row
                          gutter={[16, 16]}
                          className="proceed-to-payment-button-row"
                        >
                          <Button
                            className={`proceed-to-payment-btn ${
                              shouldDisable ? "disabled-opacity" : ""
                            }`}
                            onClick={() => {
                              if (shouldDisable) {
                                return;
                              }
                              if (
                                selectedRadio === "default" ||
                                (!radioDefaultTerms &&
                                  !radioCustomTerms &&
                                  (isCustomTermsApplied >= 1 ||
                                    (isCustomTermsApplied > 2 &&
                                      hasCampaignWithStatusTwo)))
                              ) {
                                goToSecurePayment();
                              } else if (
                                (!radioDefaultTerms &&
                                  radioCustomTerms &&
                                  isCustomTermsApplied > 0 &&
                                  isWithdrawnTerms &&
                                  everyCampaignWithStatusTwo &&
                                  allApprovedProducts) ||
                                (!radioDefaultTerms &&
                                  radioCustomTerms &&
                                  isCustomTermsApplied > 0 &&
                                  hasApproved)
                              ) {
                                goToSecurePayment();
                              } else if (selectedRadio === "custom") {
                                requestCustomTerms();
                              }
                            }}
                          >
                            <Text className="proceed-to-payment-btn-text">
                              {buttonText}
                            </Text>
                          </Button>
                        </Row>
                        {isWithdrawnTerms && (
                          <Text
                            className="withdraw-text"
                            onClick={() => {
                              setModalType("withdraw");
                              setTermsRequest(true);
                            }}
                          >
                            Withdraw the request
                          </Text>
                        )}
                      </Card>
                    </Col>
                    {!isMedium && (
                      <Col className="amp-note-store-col" xxl={6}>
                        <Card className="amp-note-store-card">
                          <Row className="product-held-row">
                            <Text className="product-held-text">Note</Text>
                            <Text className="product-held-brief-text">
                              Products aren't held while waiting. If someone
                              else buys them, they're gone. Be quick to secure
                              your spot!
                            </Text>
                          </Row>
                        </Card>
                        <Card className="amp-note-store-card amp-note-store-margin-card">
                          <Row className="product-held-row">
                            <Text className="product-held-text">
                              Did you Know?
                            </Text>
                            <Text className="cancel-campaign-text">
                              Payments are currently handled offline. You can
                              cancel your campaign anytime before it starts.
                              Refunds will be processed manually as per policy.
                            </Text>
                          </Row>
                        </Card>
                        <Card className="amp-note-store-card amp-note-store-margin-card">
                          <Row className="product-held-row">
                            <Text className="product-held-text">
                              Cancellation Policy
                            </Text>
                            <Text className="product-held-brief-text">
                              Want to know how cancellations and refunds work?
                            </Text>
                            <a
                              href={`${PDF_BASE_URL}/AMPUserAgreement.pdf`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Text className="cancellation-refund-link">
                                Cancellation & Refund Policy
                              </Text>
                            </a>
                          </Row>
                        </Card>
                      </Col>
                    )}
                  </Row> */}
              {/* {isMedium && (
                    <Row className="medium-screen-footer-note-card">
                      <Card className="amp-note-store-card">
                        <Row className="product-held-row">
                          <Text className="product-held-text">Note</Text>
                          <Text className="product-held-brief-text">
                            Products aren't held while waiting. If someone else
                            buys them, they're gone. Be quick to secure your
                            spot!
                          </Text>
                        </Row>
                      </Card>
                      <Card className="amp-note-store-card amp-note-store-margin-card">
                        <Row className="product-held-row">
                          <Text className="product-held-text">
                            Did you Know?
                          </Text>
                          <Text className="cancel-campaign-text">
                            Payments are currently handled offline. You can
                            cancel your campaign anytime before it starts.
                            Refunds will be processed manually as per policy.
                          </Text>
                        </Row>
                      </Card>
                      <Card className="amp-note-store-card amp-note-store-margin-card">
                        <Row className="product-held-row">
                          <Text className="product-held-text">
                            Cancellation Policy
                          </Text>
                          <Text className="product-held-brief-text">
                            Want to know how cancellations and refunds work?
                          </Text>
                          <Text className="cancellation-refund-link">
                            Cancellation & Refund Policy
                          </Text>
                        </Row>
                      </Card>
                    </Row>
                  )} */}
            </div>
          )}
          {currentStep === 1 && (
            <>
              <div className="secure-payment-tab-row">
                <div>
                  <IoSigining
                    selectedRadio={selectedRadio}
                    isCustomTermsApplied={isCustomTermsApplied}
                    handleStepChange={handleStepChange}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <CustomTermsModal
        termsRequest={termsRequest}
        setTermsRequest={setTermsRequest}
        modalType={modalType}
        handleRemoveTerms={handleRemoveTerms}
        allWaitingProducts={allWaitingProducts}
        allApprovedProducts={allApprovedProducts}
        allRejectedProducts={allRejectedProducts}
        waitingAndApproved={waitingAndApproved}
        waitingAndRejected={waitingAndRejected}
        approvedAndRejected={approvedAndRejected}
        mixedStatusProducts={mixedStatusProducts}
      />
      <DeleteCamapign
        setDeleteCampaignModal={setDeleteCampaignModal}
        deleteCampaignModal={deleteCampaignModal}
        type="deleteProduct"
        selectedCampaignPage={false}
        campaignPurchase={true}
        deleteCampaignId={campaignDetails?.campaign_id}
        productId={campaignDetails?.id}
        price={campaignDetails?.price}
      />
      <ReusableModal
        type={assetActionType}
        record={assetData}
        isActionModal={isActionModal}
        setIsActionModal={setIsActionModal}
        isNegotiating={isNegotiating}
        selectedChatProduct={selectedChatProduct}
        campaignDetails={campaignDetails}
      />
      <Modal
        open={isHoldRequestModalOpen}
        centered
        onCancel={() => setIsHoldRequestModalOpen(false)}
        destroyOnClose
        footer={false}
        className="product-request-hold-modal"
      >
        <ProductRequestHoldModal
          selectedProduct={selectedProduct}
          campaignDetails={selectedCampaign}
          productActionType={productActionType}
          onClose={() => {
            setIsHoldRequestModalOpen(false);
          }}
        />
      </Modal>
      {isLoading && <Spin size="large" fullscreen />}
    </>
  );
};
export default CampaignPayments;
